import { Wrapper } from '@american-autonomy/ag-ui';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const DetailsViewCardApplicationsListContainer: FunctionComponent<Props> = ({
    children,
    className = '',
    testId = TEST_ID
}) => (
    <Wrapper
        className={`${className} ${styles.detailsViewCardApplicationsListContainer}`}
        testId={testId}>
        {children}
    </Wrapper>
);

export default DetailsViewCardApplicationsListContainer;
